import { TrashIcon } from '@heroicons/react/24/solid';
import { resetDatabase } from '../utils/photos-db';

export default function ResetButton() {
  const handleReset = async () => {
    if (window.confirm('Are you sure you want to reset all data? This will clear all photos and require a new sync.')) {
      await resetDatabase();
    }
  };

  return (
    <button 
      className="options-button"
      onClick={handleReset}
    >
      <TrashIcon width={20} height={20} className="danger" />
      <span>Reset Data</span>
    </button>
  );
}